import { render, staticRenderFns } from "./StandartsCatalogModulePage.vue?vue&type=template&id=306791ae&"
import script from "./StandartsCatalogModulePage.vue?vue&type=script&lang=js&"
export * from "./StandartsCatalogModulePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports